export default "__VITE_PUBLIC_ASSET__dce6f391__"